module.exports = __webpack_public_path__ + "static/media/annaluke_engagement-21-min.8abf5752.jpg";